import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';
import { default as getObjectProperty } from 'lodash.get';

/**
 * @fucntion getErrorMessage
 * @param {String} field
 * @param {Object} values
 */
export const getErrorMessage = ({ key, ...rest }) => (
  <FormattedMessage {...rest} id={`error.${key}`} />
);
getErrorMessage.propTypes = {
  key: PropTypes.string
};

// add custom validation methods to yup
const equalTo = (ref, msg) =>
  yup.mixed().test({
    name: 'equalTo',
    exclusive: false,
    message: msg || '${path} must be the same as ${reference}', // eslint-disable-line
    params: {
      reference: ref.path
    },
    test: function(value) {
      return value === this.resolve(ref);
    }
  });
yup.addMethod(yup.string, 'equalTo', equalTo);

// used to find logged in dealer roles has a specific roleName
export const hasRole = (obj, path, roleNames) => {
  if (!obj || !path || !roleNames) {
    return;
  }

  const userRoles = getObjectProperty(obj, path, []);

  return userRoles.some(userRole => roleNames.includes(userRole));
};



// WEBPACK FOOTER //
// ./src/utils/validations.js